module.exports = __webpack_public_path__ + "static/Screen Shot 2020-05-29 at 12.19.39 PM-428165bf64b169ed7cd9727ca48b30de.png";